<template>
  <!-- 课程评价订单 -->
  <div class="index-container">
    <div class="course-container">
      <div class="nav-box">
        首页 > 大健康人才培训 > 个人中心 > 课程订单
        <span>> 订单详情</span>
      </div>
      <personalSidebar>
        <div class="right-content">
          <div class="r-title">评价订单</div>
          <div class="detail-box">
            <div class="top-box">
              <div
                class="img"
                :style="{
                  backgroundImage: 'url( ' + imgUrl + info['cover'] + ')'
                }"
              ></div>
              <div class="right-detail">
                <div class="d-title">{{ info.title }}</div>
                <div class="type-box">上课时间：{{ info.start_time }}</div>
              </div>
            </div>
            <div class="bottom-box">
              <div class="left-text">
                订单编号：{{ order_sn }}
                <span>下单时间：{{ info.create_time }}</span>
              </div>
              <div class="price-box">
                实付款：
                <span>¥</span>
                <span class="price">{{ info.price }}</span>
                <i class="iconfont-icon icon-weixinfukuan"></i>
                <span class="pay-text">微信支付</span>
              </div>
            </div>
          </div>
          <div class="score-box">
            <div>商品评分</div>
            <el-rate
              v-model="scoreNum"
              text-color="#FF9C00"
              show-score
              score-template="{value}.0"
              :colors="scoreColor"
            ></el-rate>
          </div>
          <div class="evaluate-content">
            <div>评价晒单</div>
            <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="evaluateWords"></el-input>
          </div>
          <div class="img-box">
            <el-upload
              class="img-list"
              :action="uploadUrl"
              list-type="picture-card"
              :on-remove="handleRemove"
              :on-success="successUpload"
              :file-list="fileList"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="input-emo-box">
              <i class="iconfont-icon icon-biaoqing"></i>
              表情
              <div class="emo-box">
                <VEmojiPicker @select="selectEmoji"></VEmojiPicker>
              </div>
            </div>
          </div>
          <div class="evaluate-button" @click="evaluateCourse">立即评价</div>
        </div>
      </personalSidebar>
    </div>
  </div>
</template>
<script>
import personalSidebar from '../components/personalSidebar.vue';
import api from '../api/api';
import { imgUrl } from '../api/index';
import { upload_url } from '../api/index';

export default {
  name: 'evaluateCourse',
  components: {
    personalSidebar
  },
  data() {
    return {
      imgUrl: imgUrl,
      scoreNum: 5,
      evaluateWords: '',
      uploadUrl: upload_url,
      scoreColor: ['#FF9C00', '#FF9C00', '#FF9C00', '#FF9C00', '#FF9C00'],
      course_uuid: '',
      info: {},
      order_sn: '',
      fileList: []
    };
  },
  mounted() {
    scrollTo(0, 0);
    const value = this.$route.query;
    if (value) {
      this.course_uuid = value.course_uuid;
      this.order_sn = value.order_sn;
      this.getDetail(value.course_uuid);
    }
  },
  methods: {
    //   上传
    successUpload(res, file) {
      console.log(res, file);
      if (res.result) {
        this.fileList.push(file);
        this.$message.success('上传成功！');
      } else {
        this.$message.warning('上传失败！');
      }
    },
    evaluateCourse() {
      console.log(this.fileList);
      let arr = [];
      if (this.fileList.length > 0) {
        this.fileList.forEach(element => {
          arr.push(element.response.result);
        });
      }
      const params = {
        order_sn: this.order_sn,
        detail: this.evaluateWords,
        evaluate: this.scoreNum,
        imgs: arr
      };
      api.evaluateCourse(params).then(res => {
        console.log(res);
        if (res.result) {
          this.$message.success('提交成功！');
          this.$router.go(-1);
        } else {
          this.$message.success(res.message);
        }
      });
    },
    //  获取详情
    getDetail(id) {
      api.getCourseDetail({ uuid: id }).then(res => {
        console.log(res);
        if (res.result) {
          this.info = res.result;
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    selectEmoji(emoji) {
      console.log(emoji);
      this.evaluateWords += emoji.data;
    }
  }
};
</script>
<style lang="scss" scoped>
.index-container {
  margin-top: 122PX;
  background-color: #f8f7f6;
}
.course-container {
  //   width: 72%;
  padding: 50PX 0;
  margin: 0 auto;
}
.nav-box {
  width: 72%;
  margin: 0 auto;
  font-size: 16PX;
  color: #333333;
  span {
    color: #7d7d7d;
  }
}
.right-content {
  width: 72%;
  padding: 32PX 46PX;
  background-color: #ffffff;
  .r-title {
    padding-bottom: 20PX;
    margin-bottom: 45PX;
    font-size: 20PX;
    font-weight: bold;
    border-bottom: 1PX solid #ececec;
  }
}
.detail-box {
  position: relative;
  padding: 16PX 22PX;
  margin-bottom: 36PX;
  background-color: #f6f6f6;
  .top-box {
    display: flex;
    // align-items: center;
    padding-bottom: 20PX;
    border-bottom: 1PX solid #ebebeb;
  }
  .img {
    width: 168PX;
    height: 108PX;
    background-color: #ffffff;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
  .right-detail {
    flex: 1;
    padding-left: 20PX;
  }
  .d-title {
    width: 68%;
    padding-bottom: 14PX;
    font-weight: bold;
    font-size: 16PX;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    letter-spacing: 1PX;
  }
  .type-box {
    font-size: 12PX;
    color: #666666;
    span {
      color: #999999;
    }
    .num {
      padding-left: 16PX;
    }
  }
  .bottom-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14PX 0;
  }
  .left-text {
    color: #777777;
    span {
      padding-left: 20PX;
    }
  }
  .price-box {
    color: #999999;
    span {
      color: #dd0707;
      font-weight: bold;
    }
    .price {
      font-size: 22PX;
    }
    .iconfont-icon {
      padding-left: 22PX;
      color: #6bcc03;
    }
    .pay-text {
      color: #333333;
      font-weight: normal;
    }
  }
}
.score-box,
.evaluate-content {
  display: flex;
  margin-bottom: 28PX;
  > div {
    padding-right: 22PX;
    font-size: 18PX;
    color: #8c8c8c;
  }
}
.img-box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 30PX 0 100PX;
  margin-bottom: 76PX;
  .img-list {
    width: 80%;
  }
}
/deep/ {
  .el-rate__icon {
    font-size: 20PX;
  }
  .el-textarea {
    flex: 1;
  }
  .el-textarea__inner {
    background: #fafafa;
    border-radius: 14PX;
    border: 1PX solid #d7d6d6;
  }
  .el-upload--picture-card {
    width: 88PX;
    height: 88PX;
    line-height: 88PX;
    border-radius: 4PX;
    border-color: #979797;
  }
}
.evaluate-button {
  width: 196PX;
  margin: 0 auto;
  font-size: 18PX;
  color: #ffffff;
  text-align: center;
  line-height: 50PX;
  letter-spacing: 2PX;
  background-color: #f1a373;
  border-radius: 45PX;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
.input-emo-box {
  position: relative;
  color: 18PX;
  cursor: pointer;
  &:hover {
    .emo-box {
      display: block;
    }
  }
  .iconfont-icon {
    position: relative;
    top: 4PX;
    padding-right: 4PX;
    font-size: 26PX;
    color: #ff9c00;
  }
  .emo-box {
    position: absolute;
    display: none;
    top: 30PX;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/evaluateCourse.vue